<template>
    <myframe v-if="oktmo_stat.length !== 0 || cad_stat.length !== 0 || wait" class="analyse_result" without_title without_border without_margin>
        <template v-slot:title_content>
            <h4>Анализ результатов определения кадастровой стоимости <v-select class="ml-2 d-inline-block" :searchable="false" :clearable="false" :options="type_options" v-model="type" required style="width: 560px;height: 40px;"/></h4>
        </template>

        <b-row v-if="type == 'в разрезе муниципальных образований / населенных пунктов'" class="row_stat">
            <b-col cols="6" class="h-100">
                <hierarchy_table XLSX_name="Анализ результатов" min_width="662px" :data="oktmo_stat_table" :fields_raw="oktmo_stat_fields" searchable exportXLSX>
                    <template v-slot:nav_menu_end>
                        <b-button variant="outline-primary" title="Развернуть" v-on:click="table_modal" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="Full - Short_open"/></b-button>
                    </template>
                </hierarchy_table>
            </b-col>

            <b-col cols="6" class="h-100 d-flex flex-column">
                
                <b-navbar class="px-0" style="margin-inline: -15px;">
                    <b-col cols="6">
                        <v-select :searchable="false" :clearable="false" :options="chart_fields_options" v-model="chart_fields_type" required style="height: 2.5rem;"/>
                    </b-col>
                    <b-col cols="6">
                        <b-nav class="d-flex justify-content-end" pills>
                            <b-button v-if="oktmo_stat_chart.length > 1" title="Развернуть" variant="outline-primary" v-on:click="chart_modal" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="Full - Short_open"/></b-button>
                        </b-nav>
                    </b-col>
                </b-navbar>
                <div ref="chart_div" class="w-100" style="overflow-x: auto;" v-resize v-on:resize="() => set_chart_width('chart_div', this.oktmo_stat_options, this.oktmo_stat, 'oktmo_stat_width')">
                    <GChart v-if="oktmo_stat_chart.length > 1" class="row_stat_content" type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="oktmo_stat_options" :data="oktmo_stat_chart" :style="{flex: 1, width: oktmo_stat_width+'px',}" />
                </div>
            </b-col>
        </b-row>

        <b-row v-if="type == 'в разрезе кадастровых районов / кадастровых кварталов'" class="row_stat">
            <b-col cols="6" class="h-100">
                <hierarchy_table XLSX_name="Анализ результатов" min_width="662px" :data="cad_stat_table" :fields_raw="cad_stat_fields" searchable exportXLSX>
                    <template v-slot:nav_menu_end>
                        <b-button variant="outline-primary" title="Развернуть" v-on:click="table_modal" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="Full - Short_open"/></b-button>
                    </template>
                </hierarchy_table>
            </b-col>

            <b-col cols="6" class="h-100 d-flex flex-column">
                <b-navbar class="px-0" style="margin-inline: -15px;">
                    <b-col cols="6">
                        <v-select class="ml-2" :searchable="false" :clearable="false" :options="chart_fields_options" v-model="chart_fields_type" required/>
                    </b-col>
                    <b-col cols="6">
                        <b-nav class="d-flex justify-content-end" pills>
                            <b-button v-if="cad_stat_chart.length > 1" title="Развернуть" variant="outline-primary" v-on:click="chart_modal" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="Full - Short_open"/></b-button>
                        </b-nav>
                    </b-col>
                </b-navbar>
                <div ref="chart_div" class="w-100" style="overflow-x: auto;" v-resize v-on:resize="() => set_chart_width('chart_div', this.cad_stat_options, this.cad_stat, 'cad_stat_width')">
                    <GChart v-if="cad_stat_chart.length > 1" class="row_stat_content" type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="cad_stat_options" :data="cad_stat_chart" :style="{flex: 1, width: cad_stat_width+'px',}" />
                </div>
            </b-col>
        </b-row>

        <mymodal ref='table_modal' title="Анализ результатов определения кадастровой стоимости" without_ok width="90%" :reset="() => {}">
            <hierarchy_table XLSX_name="Анализ результатов" min_width="662px" v-if="type == 'в разрезе муниципальных образований / населенных пунктов'" :data="oktmo_stat_table" :fields_raw="oktmo_stat_fields" searchable exportXLSX />
            <hierarchy_table XLSX_name="Анализ результатов" min_width="662px" v-if="type == 'в разрезе кадастровых районов / кадастровых кварталов'" :data="cad_stat_table" :fields_raw="cad_stat_fields" searchable exportXLSX />
        </mymodal>        
                
        <mymodal ref='chart_modal' title="Анализ результатов определения кадастровой стоимости" without_ok width="90%" :reset="() => {}">
            <b-navbar class="px-0" style="margin-inline: -15px;">
                <b-col cols="6">
                    <v-select :searchable="false" :clearable="false" :options="chart_fields_options" v-model="chart_fields_type" required style="height: 2.5rem;"/>
                </b-col>
            </b-navbar>
            <div ref="modal_chart" v-if="type == 'в разрезе муниципальных образований / населенных пунктов'" class="w-100" style="overflow-x: auto;overflow-y: hidden;" v-resize v-on:resize="() => set_chart_width('modal_chart', this.oktmo_stat_options, this.oktmo_stat, 'modal_oktmo_stat_width')">
                <GChart type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="oktmo_stat_options" :data="oktmo_stat_chart" :style="{'min-height': '65vh', width: modal_oktmo_stat_width+'px',}" />
            </div>
            <div ref="modal_chart" v-if="type == 'в разрезе кадастровых районов / кадастровых кварталов'" class="w-100" style="overflow-x: auto;overflow-y: hidden;" v-resize v-on:resize="() => set_chart_width('modal_chart', this.cad_stat_options, this.cad_stat, 'modal_cad_stat_width')">
                <GChart type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="cad_stat_options" :data="cad_stat_chart" :style="{'min-height': '65vh', width: modal_cad_stat_width+'px',}" />
            </div>
        </mymodal>
    </myframe>
</template>

<script>

import api from "../../../../api"
import { GChart } from "vue-google-charts"
import myframe from "../../../widgets/frame"
import hierarchy_table from "../../../widgets/hierarchy_table"
import mymodal from '../../../widgets/modal'

const colors = { min : "#007CFF", max : "#00CAFF", mid : "#4AFFD8", text : "#828281" }

export default
{
    components :
	{
		GChart,
		myframe,
		hierarchy_table,
        mymodal,
	},

	props :
	{
		id : String,
	},

    data()
	{
		return {
            wait : false,

			type : "в разрезе муниципальных образований / населенных пунктов",
			type_options : ["в разрезе муниципальных образований / населенных пунктов", "в разрезе кадастровых районов / кадастровых кварталов"],

            chart_fields_type : "Все",
            chart_fields_options : ["Все", "Минимальные значения", "Максимальные значения", "Средние значения"],

			oktmo_stat_fields :
			[
				{ key : "mun_name", label : "Наименование муниципального образования / населенного пункта", },
				{ key : "min", label : "Мин. значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "max", label : "Макс. значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "mid", label : "Среднее значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "count", label : "Количество рассчитанных объектов", tdClass : ["oktmo_stat_count_td", "text-right"], },
			],

			oktmo_stat_options :
			{
				chartArea: { top : 10, height : "60%", width : "100%", left : 120, },
				legend : { position : "bottom", alignment : "center" }, 
				series : [],
				hAxis :
                {
                    title : "Муниципальное образование",
                    slantedText: "true",
                    textStyle :
                    {
                        color: colors.text,
                        fontSize: 16
                    },
                    titleTextStyle:
                    {
                        color: colors.text,
                        italic: false,
                        fontSize: 16
                    }
                },
				vAxis:
                {
					title: 'УПКС (руб./кв. м)',
                    textStyle :
                    {
                        color: colors.text,
                        fontSize: 16
                    },
                    titleTextStyle :
                    {
                        color: colors.text,
                        italic: false,
                        fontSize: 16
                    }
				},
				tooltip: { isHtml: true }
			},

			oktmo_stat : [],

			cad_stat_fields :
			[
				{ key : "name", label : "Номер кадастрового района / кадастрового квартала", },
				{ key : "min", label : "Мин. значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "max", label : "Макс. значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "mid", label : "Среднее значение УПКС (руб./кв.&nbsp;м)", tdClass : ["oktmo_stat_td", "text-right"], },
				{ key : "count", label : "Количество рассчитанных объектов", tdClass : ["oktmo_stat_count_td", "text-right"], },
			],

            cad_stat_options :
            {
				chartArea: { top : 10, height : "70%", width : "100%", left : 120, },
				legend : { position : "bottom", alignment : "center" }, 
				series : [],
                hAxis :
                {
                    title : "Кадастровые районы",
                    slantedText : "true",
                    textStyle :
                    {
                        color: colors.text,
                        fontSize: 16
                    },
                    titleTextStyle :
                    {
                        color: colors.text,
                        italic: false,
                        fontSize: 16
                    }
                },
                vAxis:
                {
                    title: 'УПКС (руб./кв. м)',
                    textStyle :
                    {
                        color: colors.text,
                        fontSize: 16
                    },
                    titleTextStyle:
                    {
                        color: colors.text,
                        italic: false,
                        fontSize: 16
                    }
                },
				tooltip: {isHtml: true}
            },

			cad_stat : [],

            oktmo_stat_width : null,
            cad_stat_width : null,
            modal_oktmo_stat_width : null,
            modal_cad_stat_width : null,
		}
	},

    watch :
    {
        type(type)
        {
            if (type == 'в разрезе муниципальных образований / населенных пунктов')
            {
                this.set_chart_width('chart_div', this.oktmo_stat_options, this.oktmo_stat, 'oktmo_stat_width')
            }
            else
            {
                this.set_chart_width('chart_div', this.cad_stat_options, this.cad_stat, 'cad_stat_width')
            }
        }
    },

	computed :
	{
		oktmo_stat_chart()
		{
            return [
                this.get_stat_chart_header('Муниципальное образование', this.oktmo_stat_options),
                ...this.oktmo_stat
                    .map(
                        e => 
                        {
                            var row = [ e["name"], ]

                            if (this.chart_fields_type == "Минимальные значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["min"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Минимальные значения",
                                        e["stat"]["min"] ? api.number_to_string_with_ranking(e["stat"]["min"]) : null
                                    )
                                )
                            }

                            if (this.chart_fields_type == "Максимальные значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["max"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Максимальные значения",
                                        e["stat"]["max"] ? api.number_to_string_with_ranking(e["stat"]["max"]) : null
                                    )
                                )
                            }

                            if (this.chart_fields_type == "Средние значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["mid"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Средние значения",
                                        e["stat"]["mid"] ? api.number_to_string_with_ranking(e["stat"]["mid"]) : null
                                    )
                                )
                            }

                            return row
                        }
					).filter(e => e[1] != null || e[3] != null || e[5] != null)
            ]
		},
		oktmo_stat_table()
		{
			return this.get_oktmo_stat_table(this.oktmo_stat)
		},
		cad_stat_chart()
		{
			return [
                this.get_stat_chart_header('Кадастровый номер', this.cad_stat_options),
                ...this.cad_stat
                    .map(
                        e => 
                        {
                            var row = [ e["name"] ]

                            if (this.chart_fields_type == "Минимальные значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["min"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Минимальные значения",
                                        e["stat"]["min"] ? api.number_to_string_with_ranking(e["stat"]["min"]) : null
                                    )
                                )
                            }

                            if (this.chart_fields_type == "Максимальные значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["max"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Максимальные значения",
                                        e["stat"]["max"] ? api.number_to_string_with_ranking(e["stat"]["max"]) : null
                                    )
                                )
                            }

                            if (this.chart_fields_type == "Средние значения" || this.chart_fields_type == "Все")
                            {
                                row.push(
                                    e["stat"]["mid"],
                                    api.get_tooltip(
                                        e["name"],
                                        "Средние значения",
                                        e["stat"]["mid"] ? api.number_to_string_with_ranking(e["stat"]["mid"]) : null
                                    )
                                )
                            }

                            return row
                        }
                    ).filter(e => e[1] != null || e[3] != null || e[5] != null)
            ]
		},
		cad_stat_table()
		{
			return this.get_cad_stat_table(this.cad_stat)
		}
	},

	mounted()
	{
		this.refresh()
	},
    
    methods :
    {
		refresh()
		{
            this.wait = true

			api.call(this, "cadastral_groups", "get_analysis_statistics", { id : this.id },
				response =>
				{
					if(response.stat.whole_group.stat.count)
					{
						this.oktmo_stat =
						[
							response.stat.whole_group,
							response.stat.bad,
							... response.stat.gar.filter(e => !(e["stat"]["min"] == null || e["stat"]["max"] == null || e["stat"]["mid"] == null))
						]
						this.cad_stat =
						[
							response.stat.whole_group,
							response.stat.bad_cadastral_block,
							... response.stat.cadastral_block.filter(e => !(e["stat"]["min"] == null || e["stat"]["max"] == null || e["stat"]["mid"] == null))
						]
					}
					else
					{
						this.oktmo_stat = []
						this.cad_stat = []
					}
                    
                    if (this.type == 'в разрезе муниципальных образований / населенных пунктов')
                    {
                        this.set_chart_width('chart_div', this.oktmo_stat_options, this.oktmo_stat, 'oktmo_stat_width')
                    }
                    else
                    {
                        this.set_chart_width('chart_div', this.cad_stat_options, this.cad_stat, 'cad_stat_width')
                    }
                    this.wait = false
				})
		},

        get_oktmo_stat_table(data)
		{
			return data.map(e => ({
				"mun_name" : e["name"],
				"min" : api.format_cost(e["stat"]["min"], "", ""),
				"max" : api.format_cost(e["stat"]["max"], "", ""),
				"mid" : api.format_cost(e["stat"]["mid"], "", ""),
				"count" : e["stat"]["count"],
				"children" : this.get_oktmo_stat_table(e.children)
			}))
		},

		get_cad_stat_table(data)
		{
			return data.map(e => ({
				"name" : e["name"],
				"min" : api.format_cost(e["stat"]["min"], "", ""),
				"max" : api.format_cost(e["stat"]["max"], "", ""),
				"mid" : api.format_cost(e["stat"]["mid"], "", ""),
				"count" : e["stat"]["count"],
				"children" : this.get_cad_stat_table(e.children)
			}))
		},

        get_stat_chart_header(key, options)
        {
            const header = [key]
            options.series = []

            if (this.chart_fields_type == "Минимальные значения" || this.chart_fields_type == "Все")
            {
                options.series.push({ color : colors.min })
                header.push('Минимальное значение', { role : "tooltip", p: {html: true} })
            }

            if (this.chart_fields_type == "Максимальные значения" || this.chart_fields_type == "Все")
            {
                options.series.push({ color : colors.max })
                header.push('Максимальное значение', { role : "tooltip", p: {html: true} })
            }

            if (this.chart_fields_type == "Средние значения" || this.chart_fields_type == "Все")
            {
                options.series.push({ color : colors.mid })
                header.push('Среднее значение', { role : "tooltip", p: {html: true} })
            }

            return header
        },
        
        set_chart_width(ref, options, stat, width_var)
        {
            const new_width = options.chartArea.left + stat.length * 75
            this[width_var] = this.$refs[ref].offsetWidth > new_width ? this.$refs[ref].offsetWidth : new_width
        },

        table_modal()
        {
            this.$refs.table_modal.execute()
        },
        chart_modal()
		{
			this.$refs.chart_modal.execute()
		},
    }
}
</script>

<style>
.analyse_result, .analyse_result .row_stat, .analyse_result .row_stat_content
{
    flex: 1;
    overflow: hidden;
}
.analyse_result .frame_title_first_col
{
	display: none;
}
.analyse_result > div, .analyse_result .row_stat > div > div
{
    display: flex;
    flex-direction: column;
    height: 100%;
}
.oktmo_stat_table
{
    min-width: 664px;
}
.oktmo_stat_td
{
    width: 112px;
}
.oktmo_stat_count_td
{
    width: 128px;
}
</style>
